import React from 'react';

import { getCursorPositionInDOM } from '../dom/RichTextEditorHelpers';

const RichTextEditorDebugger = ({ state, editableContentId, stateDisplayClassName }) => {
  const stateDisplay = () => {
    return Object.entries(state).map(([key, value]) => {
      return (<div key={key}>{`${key}: ${value}`}</div>);
    });
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const showDebugHelper = urlParams.get('show_debug_helper');
  const isibuteDocument = state?.documentManager?.getCurrentDocument();

  if (showDebugHelper) {
    return (
      <>
        <div className={stateDisplayClassName}>
          <p>State Cursor Position: {isibuteDocument.cursorPosition}</p>
          <p>DOM Cursor Position: {getCursorPositionInDOM({ editableContentId })}</p>
          <p>Current Node Cursor Position: {isibuteDocument?.currentNodeCursorPosition}</p>
          <p>Current Node Parent Id: {isibuteDocument?.currentNode?.parentDocumentComponentId}</p>
          <p>Current Node Id: {isibuteDocument?.currentNode?.id}</p>
        </div>
        <div className={stateDisplayClassName}>
          {stateDisplay()}
        </div>
      </>
    );
  }

  return null;
};

export default RichTextEditorDebugger;
